import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { AcademicTitleInput } from './AcademicTitleInput';

export function AcademicTitleField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return <GenericInputField<TValues> {...props} Input={AcademicTitleInput} />;
}
